var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserUser3Line = function SvgUserUser3Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 18.334h-1.666v-1.667a2.5 2.5 0 0 0-2.5-2.5h-5a2.5 2.5 0 0 0-2.5 2.5v1.666H3.334v-1.666A4.167 4.167 0 0 1 7.501 12.5h5a4.166 4.166 0 0 1 4.166 4.167v1.666Zm-6.666-7.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10Zm0-1.667A3.333 3.333 0 1 0 10 2.5a3.333 3.333 0 0 0 0 6.667Z",
    fill: "#999FB4"
  })));
};
export default SvgUserUser3Line;